export const messageCenterAlignRegions = ["de", "at", "ch", "pl"];
export const linksLeftAlignRegions = ["hu"];